module.exports = __webpack_public_path__ + "img/i74.415a462d.png";